import type { ReactNode } from 'react';

/** Screen title row (Alerts / Developers artboards): h1 + a mute line, actions on the right. */
export function PageHeader({
  title,
  line,
  actions,
}: {
  title: string;
  line?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="flex items-end justify-between gap-6">
      <div className="flex flex-col gap-1.5">
        <h1 className="m-0 text-[30px] font-semibold tracking-[-0.02em]">{title}</h1>
        {line ? <div className="text-[14px] text-mute">{line}</div> : null}
      </div>
      {actions ? <div className="flex shrink-0 gap-3">{actions}</div> : null}
    </div>
  );
}

export function Main({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <main className={`flex flex-col gap-7 px-12 pt-10 pb-16 ${className}`}>
      {children}
    </main>
  );
}
